export default "__VITE_ASSET__1fc926dd__"